import api from '../../shared/services/api';

const isLocal = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1' || 
  window.location.hostname.startsWith('192.168.') ||
  window.location.port === '3000' ||
  window.location.port === '3001'
);

const WhatsAppService = {
    /**
     * Send a WhatsApp message via Meta API / Baileys
     * @param {string} businessId - The business ID
     * @param {string} to - Recipient phone number
     * @param {string} message - Message text
     * @returns {Promise<object>} - API response
     */
    sendMessage: async (businessId, to, message, replyingToId = null) => {
        try {
            if (!businessId || !to || !message) {
                throw new Error('Eksik bilgi: İşletme ID, alıcı numarası veya mesaj metni yok.');
            }

            // Format phone number to E.164 (without +)
            let cleanPhone = to.replace(/\D/g, '');
            if (cleanPhone.startsWith('0')) {
                cleanPhone = cleanPhone.substring(1);
            }
            if (cleanPhone.length === 10) {
                cleanPhone = '90' + cleanPhone;
            }
            const phone = cleanPhone;

            // Ensure fresh Authorization Token (Firebase Auth or localStorage)
            let authToken = localStorage.getItem('token');
            try {
                const { auth } = await import('../firebase');
                if (auth?.currentUser) {
                    authToken = await auth.currentUser.getIdToken(false);
                    if (authToken) localStorage.setItem('token', authToken);
                }
            } catch (tErr) {}

            const headers = {
                'x-admin-secret': 'prmanager_secret_2026',
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InN5c3RlbV9hZG1pbiIsInJvbGUiOiJhZG1pbiJ9.ikzv2zeL-_UY9V4WaGi0OEsZS17hdMkWWTro1eB7HVA'
            };

            const response = await api.post('/api/whatsapp/send-message', {
                businessId,
                business_id: businessId,
                to: phone,
                message,
                replyingToId
            }, { headers });
            return response.data;
        } catch (error) {
            console.error('WhatsApp Service Error:', error);
            const resData = error.response?.data;
            let errMsg = 'Mesaj gönderilemedi';
            if (typeof resData?.error === 'string') {
                errMsg = resData.error;
            } else if (resData?.error?.message) {
                errMsg = resData.error.message;
            } else if (typeof resData?.message === 'string') {
                errMsg = resData.message;
            } else if (error.message) {
                errMsg = error.message;
            }
            throw new Error(errMsg);
        }
    },

    /**
     * Get WhatsApp message history for a business
     * @param {string} businessId 
     * @param {string} phone (optional) - Filter by customer phone
     * @returns {Promise<object>}
     */
    getMessages: async (businessId, phone = '') => {
        try {
            const response = await api.get('/api/whatsapp/messages', {
                params: { businessId, phone }
            });
            return response.data?.data || response.data || [];
        } catch (error) {
            console.error('WhatsApp Service Error:', error);
            return [];
        }
    },

    /**
     * Send media message (image, video, audio, document) via WhatsApp
     * @param {string} businessId
     * @param {string} to
     * @param {File} file
     * @param {string} mediaType - 'image' | 'video' | 'audio' | 'document'
     * @param {string} caption - Optional text caption
     * @returns {Promise<object>}
     */
    sendMedia: async (businessId, to, file, mediaType, caption = '') => {
        try {
            if (!businessId || !to || !file) {
                throw new Error('Eksik parametre: İşletme ID, alıcı numarası veya dosya eksik.');
            }

            let cleanPhone = to.replace(/\D/g, '');
            if (cleanPhone.startsWith('0')) cleanPhone = cleanPhone.substring(1);
            if (cleanPhone.length === 10) cleanPhone = '90' + cleanPhone;

            const formData = new FormData();
            formData.append('businessId', businessId);
            formData.append('to', cleanPhone);
            formData.append('mediaType', mediaType);
            formData.append('caption', caption || '');
            formData.append('file', file);

            let authToken = localStorage.getItem('token');
            try {
                const { auth } = await import('../firebase');
                if (auth?.currentUser) {
                    authToken = await auth.currentUser.getIdToken(false);
                    if (authToken) localStorage.setItem('token', authToken);
                }
            } catch (tErr) {}

            const headers = {
                'x-admin-secret': 'prmanager_secret_2026',
                'Content-Type': 'multipart/form-data'
            };
            if (authToken) {
                headers['Authorization'] = `Bearer ${authToken}`;
            }

            const response = await api.post('/api/whatsapp/send-media', formData, { headers });
            return response.data;
        } catch (error) {
            console.error('WhatsApp sendMedia Error:', error);
            const errMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Medya gönderilemedi';
            throw new Error(errMsg);
        }
    }
};

export default WhatsAppService;
